module.exports = __webpack_public_path__ + "img/25-Skin.9683c442.png";